import { scaleToDecimalPlaces } from "../../Generic/Numbers";

/**
 * Calculate the quantity in cases and items when quantity is only in items
 */
export function determineQuantityInCasesAndItems(
    quantity: number,
    caseQuantity: number
): { cases: number; items: number; } {
    if(caseQuantity === 0 || caseQuantity === 1) {
        // Force -0 to be 0 when returned
        // noinspection PointlessArithmeticExpressionJS
        return {
            cases: 0,
            items: quantity + 0,
        };
    }

    const negative = quantity < 0 ? -1 : 1;

    // Force -0 to be 0 when returned
    // noinspection PointlessArithmeticExpressionJS
    return {
        cases: Math.floor(Math.abs(quantity) / caseQuantity) * negative + 0,
        items: scaleToDecimalPlaces(Math.abs(quantity) % caseQuantity * negative, 2) + 0,
    };
}
